import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer = () => {
  return (
    <>
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[800],
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body1" align="center">
            © {new Date().getFullYear()} {"SOLID CLASSES"}. All rights reserved.
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            <Link component={RouterLink} color="inherit" to="/contact">
              Contact Us
            </Link>
            {' | '}
            <Link component={RouterLink} color="inherit" to="/privacy">
              Privacy Policy
            </Link>
            {' | '}
            <Link component={RouterLink} color="inherit" to="/terms">
              Terms of Service
            </Link>
          </Typography>
        </Container>
      </Box>
      {/* WhatsApp Floating Button */}
      <style>{`
        @media (max-width: 600px) {
          .wa-fab {
            width: 44px !important;
            height: 44px !important;
            bottom: 16px !important;
            right: 16px !important;
          }
          .wa-fab svg {
            font-size: 24px !important;
          }
        }
      `}</style>
      <a
        href="https://wa.me/919079035708?text=Hello%2C%20I%20am%20interested%20in%20enrolling%20at%20SOLID%20CLASSES.%20Please%20provide%20more%20information."
        target="_blank"
        rel="noopener noreferrer"
        className="wa-fab"
        style={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 2000,
          backgroundColor: '#25D366',
          borderRadius: '50%',
          width: 56,
          height: 56,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          color: 'white',
          textDecoration: 'none',
          transition: 'all 0.2s',
        }}
        aria-label="Chat on WhatsApp"
      >
        <WhatsAppIcon style={{ fontSize: 32 }} />
      </a>
    </>
  );
};

export default Footer;
